import React, { useEffect, useState } from "react";
import { SpinLoader } from "~/design-system/Spinner/SpinLoader";
import { FilesListSkeleton } from "./components/FilesListSkeleton";
import { MapSkeleton } from "./components/MapSkeleton";
import { ProjectListSkeleton } from "./components/ProjectInfoSkeleton";
import { TasksListSkeleton } from "./components/TasksListSkeleton";

enum SkeletonType {
  TASKS_LIST = "tasks",
  FILES_LIST = "files",
  MAP = "map",
  PROJECT_INFO = "project",
}

const SKELETON_RENDERER = new Map([
  [
    SkeletonType.TASKS_LIST,
    <TasksListSkeleton key={SkeletonType.TASKS_LIST} />,
  ],
  [
    SkeletonType.FILES_LIST,
    <FilesListSkeleton key={SkeletonType.FILES_LIST} />,
  ],
  [SkeletonType.MAP, <MapSkeleton key={SkeletonType.MAP} />],
  [
    SkeletonType.PROJECT_INFO,
    <ProjectListSkeleton key={SkeletonType.PROJECT_INFO} />,
  ],
]);

type SkeletonProps = {
  type?: SkeletonType;
};

const Skeleton = (props: SkeletonProps) => {
  const { type } = props;
  const [render, setRender] = useState(false);

  // This timeout is introduced to avoid the "flickering" effect when the skeleton is rendered
  useEffect(() => {
    let unmounted = false;
    setTimeout(() => {
      if (!unmounted) {
        setRender(true);
      }
    }, 100);
    return () => {
      unmounted = true;
    };
  }, [setRender]);

  if (!render) {
    return null;
  }

  return SKELETON_RENDERER.get(type!) ?? <SpinLoader />;
};

export { Skeleton, SkeletonType };
